import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { productsFiles } from "./productFile";
import "./Products.css";

export default function VyraProducts() {
  const navigate = useNavigate();
  const [filter, setFilter] = useState("All");

  const categories = ["All", ...new Set(productsFiles.map((p) => p.category))];

  const filtered =
    filter === "All" ? productsFiles : productsFiles.filter((p) => p.category === filter);

  return (
    <div className="products">
      <section className="products-hero">
        <div className="container">
          <h1>Our Products</h1>
          <p>High-quality pharmaceutical formulations across multiple therapeutic segments</p>
        </div>
      </section>

      <div className="container">
        <div className="filter-bar">
          {categories.map((cat) => (
            <button
              key={cat}
              className={`filter-btn ${filter === cat ? "active" : ""}`}
              onClick={() => setFilter(cat)}
            >
              {cat}
            </button>
          ))}
        </div>

        <div className="product-grid">
          {filtered.map((item) => (
            <div
              className="product-card"
              key={item.id}
              onClick={() => navigate(`/product/${item.id}`, { state: item })}
            >
              <div className="card-image">
                <img src={item.image} alt={item.name} loading="lazy" />
              </div>
              <div className="card-content">
                <span className="category-tag">{item.category}</span>
                <h3>{item.name}</h3>
                <p className="composition">{item.composition}</p>
                <span className="view-details">View Details →</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
